<template>
    <form @submit.prevent="submit" ref="form">

        <text-input v-model="form.first_name" :errors="$page.props.errors.first_name" class="mb-3" label="Voornaam" />
        <text-input v-model="form.last_name" :errors="$page.props.errors.last_name" class="mb-3" label="Achternaam" />
        <text-input v-model="form.email" :errors="$page.props.errors.email" class="mb-3" label="Email" />
        <text-input v-model="form.jobtitle" :errors="$page.props.errors.jobtitle" class="mb-3" label="Functie" />

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";

export default {
    components: {
        TextInput,
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        user: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    data() {
        return {
            form: {
                first_name: this.user.first_name || "",
                last_name: this.user.last_name || "",
                email: this.user.email || "",
                jobtitle: this.user.jobtitle || "",
            }
        };
    },

    methods: {
        submit() {
            var data = new FormData();

            data.append("first_name", this.form.first_name);
            data.append("last_name", this.form.last_name);
            data.append("phone", this.form.phone);
            data.append("email", this.form.email);
            data.append("jobtitle", this.form.jobtitle);

            this.$emit("submit", data);
        }
    }
};
</script>
